(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '.product-information__media .product-media-container--zoomable.product-media-container--image:not(.dialog-zoomed-gallery *)';

  const getContainer = (target) => target instanceof Element ? target.closest(selector) : null;

  const reset = (container) => {
    if (!container) return;
    container.classList.remove('orvon-hover-zoom-active');
    container.style.removeProperty('--orvon-zoom-x');
    container.style.removeProperty('--orvon-zoom-y');
  };

  document.addEventListener('pointermove', (event) => {
    if (!finePointer.matches) return;

    const container = getContainer(event.target);
    if (!container) return;

    const image = container.querySelector('.product-media__image');
    if (!image) return;

    const bounds = image.getBoundingClientRect();
    const x = Math.min(100, Math.max(0, ((event.clientX - bounds.left) / bounds.width) * 100));
    const y = Math.min(100, Math.max(0, ((event.clientY - bounds.top) / bounds.height) * 100));

    container.style.setProperty('--orvon-zoom-x', `${x}%`);
    container.style.setProperty('--orvon-zoom-y', `${y}%`);
    container.classList.add('orvon-hover-zoom-active');
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    if (!finePointer.matches) return;

    const container = getContainer(event.target);
    if (!container || container.contains(event.relatedTarget)) return;
    reset(container);
  }, { passive: true });

  finePointer.addEventListener('change', () => {
    document.querySelectorAll(`${selector}.orvon-hover-zoom-active`).forEach(reset);
  });
})();
